export const HIGHLIGHTING_COLORS = {
  transparent: "Without color",
  yellow: "Yellow",
  green: "Green",
  blue: "Blue",
  pink: "Pink",
  lightblue: "Lightblue",
} as const;

export const MATH_CHARS = "≤≥×✕÷≈√π¹²³º¼½¾ν•·→°+–" as const;
